import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { ApolloProvider, ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
var netWorkErrorlink = new RetryLink();
var httpLink = new HttpLink({ uri: process.env.REACT_APP_TIMMY_GRAPHQL_URL });
var client = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([netWorkErrorlink, httpLink])
});
var withGraphQL = function (Component) {
    var Wrapper = function (props) { return (React.createElement(ApolloProvider, { client: client },
        React.createElement(Component
        // eslint-disable-next-line react/jsx-props-no-spreading
        , __assign({}, props)))); };
    return Wrapper;
};
export default withGraphQL;
//# sourceMappingURL=withGraphQL.hoc.js.map